var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgMoon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 25 25",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21.915 13.575a7.674 7.674 0 0 1-13.086 4.7 7.718 7.718 0 0 1-2.053-3.78 7.686 7.686 0 0 1 .292-4.285 7.664 7.664 0 0 1 6.547-5.001 5.913 5.913 0 0 0-1.156 3.971 5.944 5.944 0 0 0 1.73 3.764 5.944 5.944 0 0 0 3.763 1.73 5.913 5.913 0 0 0 3.972-1.157l-.009.058Z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

export default SvgMoon;